import { BrowserMultiFormatReader } from '@zxing/library';
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function EinkaufslistePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [eintraege, setEintraege] = useState([]);
  const [kategorien, setKategorien] = useState([]);
  const [zeigForm, setZeigForm] = useState(false);
  const [zeigScanner, setZeigScanner] = useState(false);
  const [form, setForm] = useState({ name: '', menge: '1', einheit: 'Stück', kategorie_id: '', notizen: '' });
  const [scan, setScan] = useState('');
  const [scanErgebnis, setScanErgebnis] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => { laden(); }, [id]);

  async function laden() {
    const [e, k] = await Promise.all([api.get(`/listen/${id}/eintraege`), api.get('/kategorien')]);
    setEintraege(e.data);
    setKategorien(k.data);
  }

  async function hinzufuegen(e) {
    e.preventDefault();
    await api.post(`/listen/${id}/eintraege`, form);
    setForm({ name: '', menge: '1', einheit: 'Stück', kategorie_id: '', notizen: '' });
    setZeigForm(false);
    setScanErgebnis(null);
    laden();
  }

  async function erledigt(eintragId) {
    await api.patch(`/eintraege/${eintragId}/erledigt`);
    laden();
  }

  async function loeschen(eintragId) {
    await api.delete(`/eintraege/${eintragId}`);
    laden();
  }

  async function erledigtLoeschen() {
    await api.delete(`/listen/${id}/erledigt`);
    laden();
  }

  async function barcodeEingabe(code) {
    if (!code) return;
    try {
      const r = await api.get(`/barcode/${code}`);
      setScan(code);
      setForm(f => ({ ...f, name: r.data.name || '', kategorie_id: '', barcode: code }));
      if (r.data.gefunden === false) {
        setScanErgebnis(null);
      } else {
        setScanErgebnis(r.data);
      }
      setZeigForm(true);
    } catch(e) {
      setScan(code);
      setForm(f => ({ ...f, barcode: code, name: '' }));
      setScanErgebnis(null);
      setZeigForm(true);
    }
  }

    async function kameraScanner() {
    setZeigScanner(true);
    await new Promise(r => setTimeout(r, 600));
    try {
      const { BrowserMultiFormatReader } = await import('@zxing/library');
      const codeReader = new BrowserMultiFormatReader();
      const videoEl = videoRef.current;
      if (!videoEl) { setZeigScanner(false); return; }

      await codeReader.decodeFromConstraints(
        { video: { facingMode: 'environment' } },
        videoEl,
        (result, err) => {
          if (result) {
            codeReader.reset();
            setZeigScanner(false);
            barcodeEingabe(result.getText());
          }
        }
      );

      // Abbrechen-Referenz speichern
      window._zxingReader = codeReader;
    } catch(e) {
      setZeigScanner(false);
      alert('Kamera Fehler: ' + (e.message || 'Unbekannt'));
    }
  }

  const offen = eintraege.filter(e => !e.erledigt);
  const erledigt_liste = eintraege.filter(e => e.erledigt);

  // Nach Kategorie gruppieren
  const gruppen = {};
  offen.forEach(e => {
    const key = e.kategorie_name || 'Sonstiges';
    if (!gruppen[key]) gruppen[key] = { icon: e.kategorie_icon || '📦', farbe: e.kategorie_farbe || '#94a3b8', items: [] };
    gruppen[key].items.push(e);
  });

  const inp = { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box', marginBottom: '10px' };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}>←</button>
        <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '700', flex: 1 }}>Einkaufsliste</h1>
        <span style={{ background: '#6366f1', color: 'white', padding: '4px 10px', borderRadius: '99px', fontSize: '13px', fontWeight: '700' }}>{offen.length}</span>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
        <button onClick={() => setZeigForm(true)} style={{ flex: 1, padding: '12px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>+ Artikel</button>
        <button onClick={kameraScanner} style={{ padding: '12px 16px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '18px' }}>📷</button>
        {erledigt_liste.length > 0 && <button onClick={erledigtLoeschen} style={{ padding: '12px 16px', background: '#fee2e2', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '13px', color: '#ef4444', fontWeight: '600' }}>🗑️ Erledigt</button>}
      </div>

      {/* Kategorien-Gruppen */}
      {Object.entries(gruppen).map(([kat, g]) => (
        <div key={kat} style={{ marginBottom: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', paddingLeft: '4px' }}>
            <span>{g.icon}</span>
            <span style={{ fontWeight: '700', fontSize: '13px', color: g.farbe, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{kat}</span>
          </div>
          {g.items.map(e => (
            <div key={e.id} style={{ background: 'white', borderRadius: '12px', padding: '12px 16px', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <button onClick={() => erledigt(e.id)} style={{ width: '26px', height: '26px', borderRadius: '50%', border: '2px solid #6366f1', background: 'white', cursor: 'pointer', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6366f1' }}>○</button>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '15px' }}>{e.name}</div>
                <div style={{ color: '#64748b', fontSize: '12px' }}>{e.menge} {e.einheit}{e.marke ? ` · ${e.marke}` : ''}</div>
              </div>
              <button onClick={() => loeschen(e.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '16px' }}>✕</button>
            </div>
          ))}
        </div>
      ))}

      {/* Erledigt */}
      {erledigt_liste.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <div style={{ color: '#94a3b8', fontSize: '13px', fontWeight: '600', marginBottom: '8px', paddingLeft: '4px' }}>✅ ERLEDIGT ({erledigt_liste.length})</div>
          {erledigt_liste.map(e => (
            <div key={e.id} style={{ background: '#f8fafc', borderRadius: '12px', padding: '12px 16px', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '12px', opacity: 0.6 }}>
              <button onClick={() => erledigt(e.id)} style={{ width: '26px', height: '26px', borderRadius: '50%', border: 'none', background: '#10b981', cursor: 'pointer', flexShrink: 0, color: 'white', fontWeight: '700' }}>✓</button>
              <div style={{ flex: 1, textDecoration: 'line-through', color: '#94a3b8', fontSize: '15px' }}>{e.name}</div>
              <button onClick={() => loeschen(e.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
            </div>
          ))}
        </div>
      )}

      {offen.length === 0 && erledigt_liste.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '64px' }}>🎉</div>
          <div style={{ fontSize: '16px', marginTop: '12px' }}>Liste ist leer!</div>
        </div>
      )}

      {/* Scanner Modal */}
      {zeigScanner && (
        <div style={{ position: 'fixed', inset: 0, background: 'black', zIndex: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <video ref={videoRef} style={{ width: '100%', maxWidth: '400px', height: '300px', background: '#111' }} muted playsInline autoPlay />
          <button onClick={() => { if (window._zxingReader) { window._zxingReader.reset(); window._zxingReader = null; } setZeigScanner(false); }}
            style={{ marginTop: '20px', padding: '12px 24px', background: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>Abbrechen</button>
        </div>
      )}

      {/* Formular Modal */}
      {zeigForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: 'white', borderRadius: '20px 20px 0 0', padding: '24px 24px 0 24px', width: '100%', maxWidth: '600px', margin: '0 auto', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ margin: '0 0 16px', fontSize: '18px' }}>➕ Artikel hinzufügen</h2>
            {scanErgebnis && (
              <div style={{ background: '#eef2ff', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px', fontSize: '13px' }}>
                📷 <strong>{scanErgebnis.name}</strong>{scanErgebnis.marke ? ` · ${scanErgebnis.marke}` : ''}
              </div>
            )}
            <form onSubmit={hinzufuegen} style={{ overflowY: 'auto', flex: 1, paddingBottom: '16px' }}>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
                <button type="button" onClick={() => { setZeigForm(false); setScanErgebnis(null); }}
                  style={{ flex: 1, padding: '14px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '15px' }}>✕ Abbrechen</button>
                <button type="submit"
                  style={{ flex: 2, padding: '14px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}>✅ Hinzufügen</button>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                <input style={{ ...inp, flex: 3, marginBottom: 0 }} placeholder="Produktname *" value={form.name}
                  onChange={e => setForm({...form, name: e.target.value})} required />
                <input style={{ ...inp, flex: 1, marginBottom: 0 }} placeholder="Barcode" value={scan}
                  onChange={e => setScan(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && barcodeEingabe(scan)} />
              </div>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                <input style={{ ...inp, flex: 1, marginBottom: 0 }} type="number" step="0.1" min="0" placeholder="Menge" value={form.menge}
                  onChange={e => setForm({...form, menge: e.target.value})} />
                <select style={{ ...inp, flex: 1, marginBottom: 0 }} value={form.einheit} onChange={e => setForm({...form, einheit: e.target.value})}>
                  {['Stück','kg','g','l','ml','Packung','Flasche','Dose','Beutel'].map(u => <option key={u}>{u}</option>)}
                </select>
              </div>
              <select style={inp} value={form.kategorie_id} onChange={e => setForm({...form, kategorie_id: e.target.value})}>
                <option value="">-- Kategorie --</option>
                {kategorien.map(k => <option key={k.id} value={k.id}>{k.icon} {k.name}</option>)}
              </select>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}
